import { render, staticRenderFns } from "./Present.vue?vue&type=template&id=03893d26&scoped=true&"
import script from "./Present.vue?vue&type=script&lang=js&"
export * from "./Present.vue?vue&type=script&lang=js&"
import style0 from "./Present.vue?vue&type=style&index=0&id=03893d26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03893d26",
  null
  
)

export default component.exports